import React, { useCallback, useEffect, useState } from 'react'
import { useStake } from '../../../../../hooks/useStake';
import useWallet from '../../../../../hooks/useWallet';

function ClaimableValue({ stake }) {
    const { getAvailableStakes, getRewards, estimateClaimRewardsGas, claimRewards, isClaiming } = useStake();
    const { address } = useWallet();
    // Format currency
    // New states for rewards and gas
    // console.log(stake, 'Failed to fetch rewards:');
    const [rewards, setRewards] = useState({
        rewardsETH: "0",
        rewardsNumber: 0,
        rewardsFormatted: "0"
    });
    const formatCurrency = (amount) => {
        if (!amount) return '$0';
        return `$${parseFloat(amount).toLocaleString()}`;
    };
    // Fetch rewards
    const fetchRewards = useCallback(async () => {
        if (!stake?.contract || !address) return;

        try {
            const rewardsData = await getRewards(stake.contract, address);
            // console.log(rewardsData, 'Failed to fetch rewards:');
            setRewards({
                rewardsETH: rewardsData?.rewardsETH || "0",
                rewardsNumber: rewardsData?.rewardsNumber || 0,
                rewardsFormatted: rewardsData?.rewardsFormatted || "0"
            });
        } catch (error) {
            console.error("Failed to fetch rewards:", error);
        }
    }, [stake, address]);

    useEffect(() => {
        fetchRewards();
    }, [fetchRewards, address]);
  return (
          <div>
          <h6>{rewards.rewardsETH}</h6>
              {/* <h6>$0</h6> */}
          {/* <h5>{rewards.rewardsETH}</h5> */}
          </div>
  )
}

export default ClaimableValue